import { type QueryKey } from "@tanstack/react-query";
import { type Dayjs } from "dayjs";
import type Granularity from "src/constants/granularity.enum";

import type IntervalType from "../../../constants/intervalType.enum";
import type MeasureType from "../../../constants/measureType.enum";
import { type GeoDataDirection } from "../../../types/dashboardDatasetDto";

export function GetLocationDashboardQueryKey(
  locationIds: string[],
  intervalType: IntervalType,
  selectedDate: Dayjs | null,
  seriesType: MeasureType,
  showFlowMapLayer: boolean,
  flowDirection: GeoDataDirection | null,
  lastDays: number | null = null,
  granularity: Granularity | null = null,
  pinned = false,
  fetchParentData = false
): QueryKey {
  return [
    `locationDashboard`,
    {
      locationIds,
      intervalType,
      selectedDate,
      seriesType,
      showFlowMapLayer,
      flowDirection,
      lastDays,
      granularity,
      pinned,
      fetchParentData,
    },
  ];
}

export function GetLocationDashboardTabQueryKey(
  locationIds: string[],
  intervalType: IntervalType,
  selectedDate: Dayjs | null,
  seriesType: MeasureType,
  lastDays: number | null = null,
  granularity: Granularity | null = null,
  pinned = false
): QueryKey {
  return [`locationDashboardTab`, { locationIds, intervalType, selectedDate, seriesType, lastDays, granularity, pinned }];
}
